import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { RapportDto, ReportAuto } from 'src/app/client-management/data-management';
import { ImportExportService } from 'src/app/client-management/import-export';
import { dns } from 'src/app/global.config';
import { NewImportExportService } from '../../_service/new-import-export.service';
import { AutoSendListComponent } from './auto-send-list/auto-send-list.component';
interface PeriodOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-auto-send-report',
  templateUrl: './auto-send-report.component.html',
  styleUrls: ['./auto-send-report.component.css']
})
export class AutoSendReportComponent implements OnInit {
    currentReportAuto: ReportAuto = new ReportAuto();
    isSending:boolean=false;
title:string
email:string
frequence:string
allPeriodOptions: PeriodOption[] = [
  { value: 'JOURNALIER', label: 'Journalier' },
  { value: 'HEBDOMADAIRE', label: 'Hebdomadaire' },
  { value: 'MENSUEL', label: 'Mensuel' }
];
availablePeriodOptions: PeriodOption[] = [];

urlToBack="generateRepport?timezoneOffset="
  constructor(
      public dialogRef: MatDialogRef<AutoSendReportComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
            private toastr: ToastrService,
                private service: ImportExportService,
                private newService:NewImportExportService,
            private dialog:MatDialog
        
  ) { }

  ngOnInit(): void {
    if(this.data.urlToBack){
      this.urlToBack=this.data.urlToBack
    }else{
      this.urlToBack="generateRepport?timezoneOffset="
    }
     this.availablePeriodOptions = this.getFilteredPeriodOptions();

  // valeur par défaut = premier choix dispo
  if (this.availablePeriodOptions.length > 0) {
    this.frequence = this.availablePeriodOptions[0].value;
  }
  }

  getFilteredPeriodOptions(): PeriodOption[] {
  const type = this.data?.repport?.type;

  if (type === 'ARRETS_GLOBAL' || type === 'STOP_NON_POI' || type === 'DAILY_STOP_BY_NON_POI') {
    return this.allPeriodOptions.filter(o => o.value !== 'MENSUEL');
  }

  return this.allPeriodOptions;
}

  openList(){
    this.dialog.open(AutoSendListComponent,{
      width:"950px"
    })
  }

  saveAutoReport() {

    if (this.isSending) {
      return;
    }

    let cmp = 0;
    this.isSending = true;
    this.currentReportAuto.period = this.frequence;
    this.currentReportAuto.emails = this.email;
    this.currentReportAuto.title = this.title;

  
    if (
      this.data.repport.type === 'KILOMETRAGE_DAILY' ||
      this.data.repport.type === 'DIVIDED_ACTIVITY_SPEED'
    ) {
     
      try {
        cmp =
          this.data.repport.dateInterval.endDate.getTime() -
          this.data.repport.dateInterval.startDate.getTime();
        cmp = cmp / 1000;
      } catch (e) {
        this.isSending = false;
        return;
      }

      if (cmp > 30 * 86400) {
        this.toastr.warning(
          'La durée pour ce rapport ne peut pas dépasser 30 jours !',
          'Alerte'
        );
        this.isSending = false;

        return;
      }
    }

    this.currentReportAuto.payload = JSON.stringify(this.data.repport);
    this.currentReportAuto.url =
      window.location.protocol +
      '//' +
      window.location.host +
      dns +
      this.urlToBack +
      new Date().getTimezoneOffset();
    this.currentReportAuto.signinUrl =
      window.location.protocol + '//' + window.location.host + dns + 'signin';

    
    this.service.add(this.currentReportAuto).subscribe(
      (reportAuto) => {

        this.toastr.success('Rapport Automatique bien ajouter !');
        this.newService.addRapport(reportAuto);
        
        //this.router.navigate(['/client/dataExport']);
        this.isSending = false;

        this.currentReportAuto = new ReportAuto();
      },
      (error) => {
        this.toastr.error('Veuillez contacter votre administrateur !');
        this.isSending = false;

      }
    );
  }
}
